import { useObserver } from "mobx-react";
import React from "react";
import { useStores } from "../../../store";
import DeletePopup from "../../recruiter/DeletePopup";
const DeleteAccount = () => {
  const { UserStore } = useStores();
  return useObserver(() => (
    <div className="flex  md:mx-0 lg:mx-0  mx-1 md:mb-10 lg:mb-10 mb-24  rounded-lg bg-[#F4F4F4]">
      {UserStore?.DeletePopup && <DeletePopup />}
      <div className=" w-full ">
        <h2 className="text-xl font-semibold mt-5 ml-6 text-gray-700 mb-4">
          Delete Account
        </h2>
        <form>
          <p className="text-gray-600 bg-white ml-6 border text-sm p-4 rounded-lg mr-4 border-gray-300">
            The "<span className="font-bold">Delete Account</span>" feature
            permanently removes user accounts and associated data, ensuring
            privacy and compliance with data protection laws. Users must confirm
            their intent by verifying credentials to prevent accidental
            deletions. Once confirmed, all data is irreversibly deleted, and
            access to services is lost, providing users full control over their
            data.
          </p>
          <div className="flex  items-center bg-[#FF1616] bg-opacity-10 justify-end rounded-lg mt-10 p-4">
            <button
              onClick={() => UserStore.setDeletePopup(true)}
              type="button"
              className="bg-[#FF0000] text-white px-10 py-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600"
            >
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  ));
};
export default DeleteAccount;
